<template>
  <div class="report-main" style="background:#fff">
    {{reportName}} Report
    <Input textAlign="center" :placeholder="inputPlaceholder" :inputValue.sync="refNo" @enter="pdfClicked"/>
    <!-- <Input v-if="reportName == 'Delivery Note'"  textAlign="center" placeholder="DN No" :inputValue.sync="refNo" @enter="pdfClicked"/> -->
    <button @click="pdfClicked">Generate Report</button>
    <Loader :isVisible.sync="loading" :loadingText="loadText" :isFullScreen="true" />
    <div class="error-message">{{ errorMessage }}</div>
    <iframe v-if="pdfLink" :src="pdfLink" id="iframe" frameborder="0"></iframe>
  </div>
</template>

<script>
/* eslint-disable */
import Loader from '@/components/Loader.vue';
import Input from '@/components/Input.vue';
export default {
  components: {
    Loader, Input
  },
  data () {
    return {
      reportName: '',
      refNo: '',
      loading: false,
      loadText: '',
      errorMessage: '',
      pdfLink: '',
      // reportList: [
      //   'Job Sheet',
      //   'Delivery Note',
      //   'Container Attachment',
      // ],
      reportNameToRefNo: {
        'Job Sheet': 'Job No',
        'Delivery Note': 'DN No',
        'Container Attachment': 'Job No',
      },
      inputPlaceholder: '',
    }
  },
  async mounted() {
    this.reportName = await this.$route.params.ReportName;
    this.refNo = (this.$route.params.refNo) ? this.$route.params.refNo : '';
    this.inputPlaceholder = this.reportNameToRefNo[this.reportName] ? this.reportNameToRefNo[this.reportName] : '';
    
    // switch (this.reportName) {
    //   case 'Job Sheet':
    //     this.inputPlaceholder = 'Job No';
    //     break;
    //   case 'Delivery Note':
    //     this.inputPlaceholder = 'DN No';
    //     break;
    //   case 'Container Attachment':
    //     this.inputPlaceholder = ''
    // }
    
    this.checkPage();
    if (this.refNo) { 
      this.pdfClicked();
      this.$bus.$on('backgroundColorChanged', (color) => {
        this.backgroundColor = color;
      });
    }
  },
  methods: {
    checkPage: function() {
      try {
        var checkPages = Object.keys(this.reportNameToRefNo).filter((r) => { return r == this.reportName }); //filter by report name param passed in URL
        if (checkPages.length < 1) { this.$router.push('/*'); } // if report name passed is not in reportList, redirect to /*
      } catch (e) { console.log(e); }
    },
    pdfClicked: async function() { // generate report clicked
      this.errorMessage = '';
      if (!this.refNo) { // if no job sheet or delivery note number is provided
        this.errorMessage = `Please enter your ${this.reportName} No`; // display error message
        return;
      }
      this.loadText = 'Getting Report Details';
      this.loading = true;
      switch (this.reportName) {
        case 'Job Sheet':
          await this.getJobSheetReport(); 
          break;
        case 'Delivery Note':
          await this.getDNReport();
          break;
        case 'Container Attachment':
          await this.getContainerAttachmentReport();
          break;
      }
      this.loading = false;
    },
    // Report Functions
    getJobSheetReport: async function() {
      var loginDetails = await this.$apiCallV2('/Login/GetDetails');
      try { // call api to get details about job with the specified job number passed in URL params
        var jsDetails = await this.$apiCallV2(`/Report/GetJobDetails?config=${loginDetails.ConfigCode}&userID=${loginDetails.LoginUserID}&jobno=${this.refNo}`, loginDetails);
      } catch (e) { console.log(e); }
      
      if (jsDetails.data.length == 0) { // no job with that job number found
        this.loading = false;
        this.errorMessage = `Invalid Job No '${this.refNo}'.\nPlease enter a valid Job No`;
        return;
      }
      jsDetails.data.JobDetails.Job['companyName'] = loginDetails.CoName;
      // jsDetails.data.JobDetails.Job['timePrinted'] = this.getLocalTime(); // changed to use $dateTime instead

      try {
        // API call to get user's preferred date format
        let userOptionsData = await this.$apiCallV2('/UserOptions/GetSettingsSystemUser?settings=UserOptions');
        let preferredDateFormat = JSON.parse(userOptionsData.data[0].SettingsValue).PreferredDateFormat;

        // append preferred date format and current time onto data
        jsDetails.data.JobDetails.Job['dateFormat'] = preferredDateFormat;
        jsDetails.data.JobDetails.Job['timePrinted'] = this.$dateTime.getDateTime(new Date(), `${preferredDateFormat} HH:mm`);
      } catch (e) {
        jsDetails.data.JobDetails.Job['dateFormat'] = "dd-MM-yyyy"; // default date format
        jsDetails.data.JobDetails.Job['timePrinted'] = this.$dateTime.getDateTime(new Date(), "dd-MM-yyyy HH:mm"); // current time
        console.log(e);
      }
      
      

      var jsReportData = {
        template: { shortid: 'ofztrcpu5B' },
        data: jsDetails.data.JobDetails.Job,
        options: { 'Content-Disposition': 'attachment;filename=report.pdf'}
      };
      await this.getJSReportPDF(jsReportData);
    },
    getDNReport: async function () {
      var loginDetails = await this.$apiCallV2('/Login/GetDetails');
      var dnDetails = await this.$apiCallV2(`/Report/GetDeliveryNoteDetails?config=${loginDetails.ConfigCode}&userID=${loginDetails.LoginUserID}&dnno=${this.refNo}`, loginDetails);
      if (dnDetails.data.length == 0) {
        this.loading = false;
        this.errorMessage = `Invalid Delivery Note '${this.refNo}'.\nPlease enter a valid Delivery Note`;
        return;
      }
      // dnDetails.data[0]['ROTDate'] = this.convertDate(dnDetails.data[0]['ROTDate'], 'dd/MM/yy');
      // dnDetails.data[0]['Date_ETA'] = this.convertDate(dnDetails.data[0]['Date_ETA'], 'dd/MM/yy');
      // changed to use the user's preferred date format

      try {
        // API call to get user's preferred date format
        let userOptionsData = await this.$apiCallV2('/UserOptions/GetSettingsSystemUser?settings=UserOptions');
        let preferredDateFormat = JSON.parse(userOptionsData.data[0].SettingsValue).PreferredDateFormat;

        dnDetails.data[0]['ROTDate'] = this.convertDate(dnDetails.data[0]['ROTDate'], preferredDateFormat);
        dnDetails.data[0]['Date_ETA'] = this.convertDate(dnDetails.data[0]['Date_ETA'], preferredDateFormat);
      } catch (e) {
        dnDetails.data[0]['ROTDate'] = this.convertDate(dnDetails.data[0]['ROTDate'], "dd-MM-yy");
        dnDetails.data[0]['Date_ETA'] = this.convertDate(dnDetails.data[0]['Date_ETA'], "dd-MM-yy");
      }

      var jsReportData = {
        template: { shortid: 'BJl6F_jNVD' },
        data: dnDetails.data[0],
        options: { 'Content-Disposition': 'attachment;filename=report.pdf' }
      }
      await this.getJSReportPDF(jsReportData);
    },
    getContainerAttachmentReport: async function() {
      var loginDetails = await this.$apiCallV2('/Login/GetDetails');
      try { // call api to get details about job with the specified job number passed in URL params
        var jsDetails = await this.$apiCallV2(`/Report/GetJobDetails?config=${loginDetails.ConfigCode}&userID=${loginDetails.LoginUserID}&jobno=${this.refNo}&rpt=RptJobContainerAttach`);
      } catch (e) { console.log(e); }
      
      if (jsDetails.data.length == 0) { // no job with that job number found
        this.loading = false;
        this.errorMessage = `Invalid Job No '${this.refNo}'.\nPlease enter a valid Job No`;
        return;
      }
      
      jsDetails.data.JobDetails.Job['companyName'] = loginDetails.CoName;
      // jsDetails.data.JobDetails.Job['timePrinted'] = this.getLocalTime(); // changed to use $dateTime instead

      try {
        // API call to get user's preferred date format
        let userOptionsData = await this.$apiCallV2('/UserOptions/GetSettingsSystemUser?settings=UserOptions');
        let preferredDateFormat = JSON.parse(userOptionsData.data[0].SettingsValue).PreferredDateFormat;

        // append preferred date format and current time onto data
        jsDetails.data.JobDetails.Job['dateFormat'] = preferredDateFormat;
        jsDetails.data.JobDetails.Job['timePrinted'] = this.$dateTime.getDateTime(new Date(), `${preferredDateFormat} HH:mm`);
      } catch (e) {
        jsDetails.data.JobDetails.Job['dateFormat'] = "dd-MM-yyyy"; // default date format
        jsDetails.data.JobDetails.Job['timePrinted'] = this.$dateTime.getDateTime(new Date(), "dd-MM-yyyy HH:mm"); // current time
        console.log(e);
      }

      var jsReportData = {
        template: { shortid: 'IOGDOq8Rr' },
        data: jsDetails.data.JobDetails.Job,
        options: { 'Content-Disposition': 'attachment;filename=report.pdf'}
      };

      await this.getJSReportPDF(jsReportData);
    },
    getJSReportPDF: async function(data) {
      this.loadText = 'Creating Report';
      const headerInfo = {
        'Content-Type': 'application/json',
        'Authorization': 'Basic YWRtaW46ZG1fNTU2OWRz'
      };
      try {
        var jsReportPDF = await this.$apiCallV2('https://dsm.logistics.systems:5488/api/report', data, { headers: headerInfo, responseType: 'arraybuffer' });

        var contentType = jsReportPDF.headers['content-type'];
        var blob = new Blob([ jsReportPDF.data ], { type: contentType });
        var url = window.URL.createObjectURL(blob, { oneTimeOnly: false });
        var link = document.createElement('a');
        link.href = url;
        this.pdfLink = url;
        setTimeout(() => {
          var frame = document.getElementById('iframe').contentWindow;
          frame.focus();
          frame.print();
        }, 100);
      } catch(e) {
        this.loading = false;
        this.errorMessage = 'There was an error while creating your report';
        console.log(e);
      }
    },
    
    // Report Function
    // Utility Functions
    convertDate: function(dateString, format) {
      var dateMilli = dateString;
      dateMilli = dateMilli.split('/').join('');
      dateMilli = dateMilli.split('(').join('');
      dateMilli = dateMilli.split(')').join('');
      dateMilli = dateMilli.split('Date').join('');
      var dateObj = new Date(Number(dateMilli));
      return this.$dateTime.getDateTime(dateObj, format);
    },
    // getLocalTime: function() {
    //   var today = new Date();
    //   var dd = String(today.getDate()).padStart(2, '0');
    //   var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    //   var yyyy = today.getFullYear();
    //   var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    //   today = dd + '/' + mm + '/' + yyyy + ' ' + time;
    //   return today;
    // },
  }
}
</script>

<style lang="scss">
@import '@/css/all.scss';
.report-main {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  display: flex;
  font-size:12px;
  flex-direction: column;
  align-items: center;
  > iframe {
    width: 100%;
    height: 100%;
  }
  > .error-message {
    color: red;
    width: 100%;
    text-align: center;
    margin-top: 5px;
    white-space: pre-wrap;
  }
}
</style>